<template>
  <div class="project-register-add">
    <Spin v-if="loading"></Spin>
    <add-zheng-zhou-ren-she v-else-if="mode==='ZhengZhouRenShe'" />
    <add-jiao-zuo-ren-she v-else-if="mode==='JiaoZuoRenShe'" />
    <add-hai-nan-ren-she v-else-if="mode==='HaiNanRenShe'" />
    <Alert type="error" show-icon v-else>
      啊偶！出错了
      <span slot="desc">
        您没有访问当前页面的权限
      </span>
    </Alert>
  </div>
</template>

<script>
import AddZhengZhouRenShe from './ZhengZhouRenShe/Add.vue'
import AddJiaoZuoRenShe from './JiaoZuoRenShe/Add.vue'
import AddHaiNanRenShe from './HaiNanRenShe/Add.vue'
export default {
  name: 'project-register-add',
  props: {
  },
  components: {
    AddZhengZhouRenShe,
    AddJiaoZuoRenShe,
    AddHaiNanRenShe
  },
  data () {
    return {
      loading: false,
      supvPerms: {
        canAuditGuarantor: false,
        canPreAuditGuarantor: false,
        canBlacklistGuarantor: false,
        canClaim: false,
        canAddProjectRegister: false,
        canAuditProjectRegister: false,
        projectRegisterMode: null
      },
      mode: ''
    }
  },
  watch: {
  },
  async mounted () {
    await this.getMySupervisionPermission()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async getMySupervisionPermission () {
      this.loading = true
      await this.$Api.Supervisor.getMySupervisorPermissions()
      .then((res) => {
        // console.log(res)
        this.supvPerms = res
        this.mode = res.projectRegisterMode
        this.loading = false
        return Promise.resolve()
      })
      .catch((err) => {
        this.loading = false
        this.supvPerms = {
          canAuditGuarantor: false,
          canPreAuditGuarantor: false,
          canBlacklistGuarantor: false,
          canClaim: false,
          canAddProjectRegister: false,
          canAuditProjectRegister: false,
          projectRegisterMode: null
        }
        return Promise.reject(err)
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
